import { useContext, createContext, useState, useEffect } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const CompanySettingContext = createContext()

const getCurrencySymbol = (currency) => {
    switch (currency) {
        case 'USD':
            return '$';
        case 'INR':
            return '₹';
        case 'EUR':
            return '€';
        default:
            return '';
    }
};

const CompanySettingProvider = ({ children }) => {
    const { headers, toast } = useAuth();

    const [currency, setCurrency] = useState("")
    const [companyLogo, setCompanyLogo] = useState(null)
    const [companyName, setCompanyName] = useState(null)

    useEffect(() => {
        if (!currency && headers.Authorization !== '') {
            getSingleCompany();
        }
    }, [currency, companyLogo, headers, companyName])


    //Get Single company
    const getSingleCompany = async () => {
        try {
            let { data } = await axios.get(`${baseURL}/company-setting/single-company`, { headers })
            if (data.error === false) {
                setCurrency(getCurrencySymbol(data.data.currency))
                setCompanyLogo(data.data.logo)
                setCompanyName(data.data.name)
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Setting', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    //update company
    const updateCompany = async (companyDetail) => {
        try {
            const { data } = await axios.put(`${baseURL}/company-setting/update`, companyDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Setting', detail: data.message, life: 3000 })
                }, 500);
                getSingleCompany()
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'Setting', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    toast.current?.show({ severity: 'error', summary: 'Setting', detail: errors[0].msg, life: 3000 })
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Setting', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    return (
        <CompanySettingContext.Provider value={{ getSingleCompany, updateCompany, currency, companyLogo, companyName }}>
            {children}
        </CompanySettingContext.Provider>
    )
}

const useCompanySetting = () => useContext(CompanySettingContext)

export { useCompanySetting, CompanySettingProvider }